<template lang="pug">

transition(
  @enter="enter"
  @leave="leave"
)
  nav.l-nav(
    v-show="store.ui.state.nav"
  )
    .l-nav__inner(
      :style="{height:store.browser.state.windowHeight + 'px'}"
    )
      .l-nav__bg
      .l-nav__box1
        ul.l-nav__ul
          li.l-nav__ul__li
            .l-nav__ul__li__item1
              .l-nav__ul__li__item1__img.hondou
                .l-nav__ul__li__item1__img__obj
              .l-nav__ul__li__item1__info
                p.l-nav__ul__li__item1__info__title
                  span.l-nav__ul__li__item1__info__title__obj 山頂本堂
                .l-nav__ul__li__item1__info__box
                  .l-nav__ul__li__item1__info__box__periphery
                    a.l-nav__ul__li__item1__info__box__a(@click="navClick('/map2')")
                      span.l-nav__ul__li__item1__info__box__a__txt 周辺
                      span.l-nav__ul__li__item1__info__box__a__arrow
                  .l-nav__ul__li__item1__info__box__detail
                    a.l-nav__ul__li__item1__info__box__a(@click="navClick('/map3')")
                      span.l-nav__ul__li__item1__info__box__a__txt 詳細
                      span.l-nav__ul__li__item1__info__box__a__arrow
          li.l-nav__ul__li
            .l-nav__ul__li__item1
              .l-nav__ul__li__item1__img.hououden
                .l-nav__ul__li__item1__img__obj
              .l-nav__ul__li__item1__info
                p.l-nav__ul__li__item1__info__title
                  span.l-nav__ul__li__item1__info__title__obj 西之坊鳳凰殿
                .l-nav__ul__li__item1__info__box
                  .l-nav__ul__li__item1__info__box__periphery
                    a.l-nav__ul__li__item1__info__box__a(@click="navClick('/map4')")
                      span.l-nav__ul__li__item1__info__box__a__txt 周辺
                      span.l-nav__ul__li__item1__info__box__a__arrow
                  .l-nav__ul__li__item1__info__box__detail
                    a.l-nav__ul__li__item1__info__box__a(@click="navClick('/map5')")
                      span.l-nav__ul__li__item1__info__box__a__txt 詳細
                      span.l-nav__ul__li__item1__info__box__a__arrow
          li.l-nav__ul__li
            .l-nav__ul__li__item2
              .l-nav__ul__li__item2__box
                a.l-nav__ul__li__item2__box__a(href="/")
                  span.l-nav__ul__li__item2__box__a__txt くりからしるべトップ
                  span.l-nav__ul__li__item2__box__a__arrow
          li.l-nav__ul__li
            .l-nav__ul__li__item2
              .l-nav__ul__li__item2__box
                a.l-nav__ul__li__item2__box__a(href="https://www.kurikara.or.jp/",target="_blank")
                  span.l-nav__ul__li__item2__box__a__txt 倶利伽羅不動寺公式サイト
                  span.l-nav__ul__li__item2__box__a__arrow

        .l-nav__sns
          p.l-nav__sns__title
            span.l-nav__sns__title__obj 公式SNS
          ul.l-nav__sns__ul
            li.l-nav__sns__ul__li
              a.l-nav__sns__ul__li__item.instagram(href="https://www.instagram.com/kurikara_fudouji/",target="_blank")
            li.l-nav__sns__ul__li
              a.l-nav__sns__ul__li__item.twitter(href="https://twitter.com/Kurikara_fudou",target="_blank")
            li.l-nav__sns__ul__li
              a.l-nav__sns__ul__li__item.youtube(href="https://www.youtube.com/user/kurikarahudouji",target="_blank")

        .l-nav__copyright
          p.l-nav__copyright__txt COPYRIGHT © 倶利迦羅不動寺 ALL RIGHTS RESERVED.

      .l-nav__box2
        p.l-nav__logo
          span.l-nav__logo__txt くりからしるべ
          span.l-nav__logo__mark


</template>

<style lang="stylus" scoped>
@import '~@/assets/styles/foundation/_variables.styl'

.l-nav
  posf(0,0,49)
  width 100vw
  height 0vh
  font_notoserif_black()
  overflow hidden
  &__inner
    width 100vw
    height 100vh
    position relative
  &__bg
    background-color #e6e6e6
    pos()
    wh()
  &__box1
    pos(0,0,5)
    flexc()
    flex-wrap wrap
    +pc()
      left calc(50% + 80px)
      width 326px
      height 100%
      padding-bottom 35px
    +sp()
      width 590px
      height 100%
      left 80px
      padding-bottom 100px
  &__ul
    +sp()
      margin-left auto
      margin-right 0
    &__li
      border-bottom 1px solid #bbbbbb
      overflow hidden
      +pc()
        width 326px
      +sp()
        width 410px
      &__item1
        position relative
        display flex
        justify-content flex-start
        align-content center
        align-items center
        +pc()
          wh(100%,115px)
        +sp()
          wh(100%,212px)
        &__img
          pos()
          top auto
          overflow hidden
          &.hondou
            +pc()
              left 30px
            +sp()
              left 22px
          &.hououden
            +pc()
              left 28px
            +sp()
              left 18px
          &__obj
            ^[4].hondou &
              +pc()
                bg2('../../assets/images/ui-nav-img-hondou.png')
                left 30px
              +sp()
                bg2('../../assets/images/ui-nav-img-hondou.png',1.1)
                left 22px
            ^[4].hououden &
              +pc()
                bg2('../../assets/images/ui-nav-img-hououden.png')
                left 28px
              +sp()
                bg2('../../assets/images/ui-nav-img-hououden.png',1.1)
                left 18px
        &__info
          +pc()
            padding-left 160px
          +sp()
            padding-left 160px
          &__title
            overflow hidden
            &__obj
              display block
              font_notoserif_semibold()
              +pc()
                font-size 14px
              +sp()
                font-size 24px
          &__box
            display flex
            justify-content flex-start
            overflow hidden
            +pc()
              margin-top 17px
              padding-bottom 7px
            +sp()
              margin-top 35px
              padding-bottom 3px
            &__a
              cursor pointer
              display inline-block
              // +pc()
              //   transition opacity 200ms
              //   &:hover
              //     opacity 0.75
              &__txt
                display inline-block
                +pc()
                  font-size 16px
                +sp()
                  font-size 26px
              &__arrow
                display inline-block
                margin-right 2px
                +pc()
                  transition transform 100ms
                  ^[6]:hover &
                    transform translateX(2px)
                &:after
                  content ">"
                  display inline-block
                  position relative
                  font_notoserif_black()
                  +pc()
                    font-size 12px
                    margin-left 16px
                    top -1px
                  +sp()
                    font-size 20px
                    margin-left 26px
                    top -2px
            &__periphery,
            &__detail
              overflow hidden
            &__periphery
              +pc()
                margin-right 22px
              +sp()
                margin-right 36px

      &__item2
        position relative
        display flex
        justify-content space-between
        align-content center
        align-items center
        +pc()
          wh(270px,75px)
          margin-left 26px
          // transition opacity 200ms
          // &:hover
          //   opacity 0.75
        +sp()
          wh(360px,142px)
          margin-left 20px
        &__box
          overflow hidden
          width 100%
          &__a
            display flex
            width 100%
            justify-content space-between
            align-content center
            align-items center
            &__txt
              display inline-block
              +pc()
                font-size 16px
              +sp()
                font-size 26px
            &__arrow
              position absolute
              right 2px
              top auto
              +pc()
                transition transform 100ms
                ^[3]:hover &
                  transform translateX(2px)
              &:after
                content ">"
                display inline-block
                position relative
                font_notoserif_black()
                +pc()
                  font-size 12px
                  margin-left 16px
                  top -3px
                +sp()
                  font-size 20px
                  margin-left 26px
                  top -2px
  &__sns
    display flex
    justify-content flex-start
    align-content center
    align-items center
    +pc()
      margin-top 30px
      width 270px
    +sp()
      width 410px
      margin-top 58px
      margin-left auto
      margin-right 0
      padding-left 20px

    &__title
      overflow hidden
      &__obj
        display block
        +pc()
          font-size 14px
        +sp()
          font-size 24px
    &__ul
      flexc()
      // overflow hidden
      margin-left 28px
      &__li
        transform scale(0)
        +pc()
          margin-left 16px
        +sp()
          margin-left 22px
        &:first-child
          margin-left 0
        &__item
          +pc()
            transition transform 150ms
            &:hover
              transform scale(1.15)
          &.instagram
            +pc()
              bg2('../../assets/images/ui-nav-ico-instagram.png')
            +sp()
              bg2('../../assets/images/ui-nav-ico-instagram.png',1.7)
          &.twitter
            +pc()
              bg2('../../assets/images/ui-nav-ico-twitter.png')
            +sp()
              bg2('../../assets/images/ui-nav-ico-twitter.png',1.7)
          &.youtube
            +pc()
              bg2('../../assets/images/ui-nav-ico-youtube.png')
            +sp()
              bg2('../../assets/images/ui-nav-ico-youtube.png',1.7)

  &__copyright
    overflow hidden
    font_notosans()
    +pc()
      font-size 11px
      margin-top 74px
    +sp()
      font-size 20px
      width 100%
      posb(0,35px)
      text-align center
      padding-left 10px
    &__txt
      position relative

  &__box2
    posr(0,0,5)
    flexc()
    +pc()
      right calc(50% + 70px)
      width 386px
      height 100%
      padding-bottom 80px
    +sp()
      pos(0,0,1)
      wh()
  
  &__logo
    position relative
    +sp()
      wh()
    &__txt
      opacity 0
      +pc()
        bg2('../../assets/images/ui-nav-logo-txt.png')
        pos(142px,24px,2)
      +sp()
        bg('../../assets/images/ui-nav-logo-txt.png',0.59)
        pos(81px,50px,2)
    &__mark
      opacity 0
      +pc()
        bg2('../../assets/images/ui-nav-logo-mark.png')
      +sp()
        bg('../../assets/images/ui-nav-logo-mark.png',0.92)
        pos(-240px,550px)
</style>

<script>
import $ from 'jquery'
import gsap from 'gsap'
import { defineComponent, computed, reactive } from "vue"
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'


export default defineComponent({
  name:'Nav',

  components:{},

  setup(props, context) {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()

    const styleObject = computed(()=>{
      return {
        height:store.browser.state.windowHeight
      }
    })

    const enter = (el, done)=> {
      gsap.to(
        el,
        {height:store.browser.state.windowHeight,duration:1.0,ease:'power4.inOut',delay:0.00,onComplete:()=>{
          done()
        }}
      )

      let items = []
      $(el).find('.l-nav__ul__li__item1__img__obj').each((i,v)=>{
        items.push(v)
      })
      $(el).find('.l-nav__ul__li__item1__info__title__obj').each((i,v)=>{
        items.push(v)
      })
      $(el).find('.l-nav__ul__li__item1__info__box__a').each((i,v)=>{
        items.push(v)
      })
      $(el).find('.l-nav__ul__li__item2__box__a').each((i,v)=>{
        items.push(v)
      })
      $(el).find('.l-nav__sns__title__obj').each((i,v)=>{
        items.push(v)
      })
      items.forEach((v,i)=>{
        let tl = gsap.timeline({delay:i * 0.0 + 0.2})
        tl.fromTo(v,{y:'100%'},{y:'0%',duration:1.2,ease:'power4.inOut'})
      })

      $(el).find('.l-nav__sns__ul__li').each((i,v)=>{
        let tl = gsap.timeline({delay:i * 0.0 + 0.2})
        tl.to(v,{scale:1,duration:1.2,ease:'power4.inOut'})
      })

      gsap.to($(el).find('.l-nav__logo__txt'),{opacity:1,duration:1.0,ease:'linear',delay:0.5})
      gsap.to($(el).find('.l-nav__logo__mark'),{opacity:1,duration:1.0,ease:'linear',delay:0.2})

      gsap.to($(el).find('.l-nav__copyright__txt'),{y:'0%',duration:1.0,ease:'power4.inOut'})
    }
    const leave = (el, done)=> {
      gsap.to(
        el,
        {height:0,duration:1.0,ease:'power4.inOut',delay:0.00,onComplete:()=>{
          done()
        }}
      )

      let items = []
      $(el).find('.l-nav__ul__li__item1__img__obj').each((i,v)=>{
        items.push(v)
      })
      $(el).find('.l-nav__ul__li__item1__info__title__obj').each((i,v)=>{
        items.push(v)
      })
      $(el).find('.l-nav__ul__li__item1__info__box__a').each((i,v)=>{
        items.push(v)
      })
      $(el).find('.l-nav__ul__li__item2__box__a').each((i,v)=>{
        items.push(v)
      })
      $(el).find('.l-nav__sns__title__obj').each((i,v)=>{
        items.push(v)
      })
      items.reverse()
      items.forEach((v,i)=>{
        let tl = gsap.timeline({delay:i * 0.0 + 0.0})
        tl.to(v,{y:'100%',duration:1.0,ease:'power4.inOut'})
      })

      $(el).find('.l-nav__sns__ul__li').each((i,v)=>{
        let tl = gsap.timeline({delay:i * 0.0 + 0.0})
        tl.to(v,{scale:0,duration:1.0,ease:'power4.inOut'})
      })

      gsap.to($(el).find('.l-nav__logo__txt'),{opacity:0,duration:1.0,ease:'linear',delay:0})
      gsap.to($(el).find('.l-nav__logo__mark'),{opacity:0,duration:1.0,ease:'linear',delay:0})

      gsap.to($(el).find('.l-nav__copyright__txt'),{y:'100%',duration:1.0,ease:'power4.inOut'})
    }
    const navClick = (url)=> {
      router.push(url)
      store.ui.state.nav = false
    }

    return{
      store,
      enter,
      leave,
      navClick
    }
  }
})
</script>
